import axios from "axios";

const ibgeApi = axios.create({
  baseURL: "https://servicodados.ibge.gov.br/api/v1/localidades",
  timeout: 10000,
});

const mapState = (state) => ({
  value: state.sigla,
  label: state.nome,
});

const mapCity = (city) => ({
  value: city.nome,
  label: city.nome,
});

export async function getBrazilianStates() {
  const { data } = await ibgeApi.get("/estados", {
    params: {
      orderBy: "nome",
    },
  });

  return data.map(mapState);
}

export async function getCitiesByState(stateCode) {
  const { data } = await ibgeApi.get(`/estados/${stateCode}/municipios`, {
    params: {
      orderBy: "nome",
    },
  });

  return data.map(mapCity);
}
